export class SupportingInfoPayload {

    public token: string = '';
    public doc1: any;
    public doc2: any;
    public doc3: any;
    public jobID: number = 0;
    public userId: number = 0;
    public supportingInfo: string = '';
    public referralCode: string = '';

}
